import * as React from "react";
import { Label } from "components/bootstrap";
const DataLakeBackendState = ({ isActiveBackend }) => {
  if (!isActiveBackend) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: "success", bsSize: "xsmall" }, "Active");
};
export default DataLakeBackendState;
